import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="fancy-select"
export default class extends Controller {
  static targets = ["list", "item", "selected", "input"];

  connect() {
    document.addEventListener("click", this.handleClickOutside.bind(this));
    this.setDefaultIfPossible();
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside.bind(this));
  }

  toggle() {
    if (this.listTarget.classList.contains("hidden")) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.listTarget.classList.remove("hidden");
  }

  close() {
    this.listTarget.classList.add("hidden");
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  setDefaultIfPossible() {
    const id = this.element.dataset.defaultValue;
    if (id) {
      console.log("Mam default value:", { id });
      const selectItem = this.itemTargets.find((item) => item.dataset.id == id);
      this.selectedTarget.innerHTML =
        selectItem.querySelector(`[data-js="title"]`).outerHTML;
      selectItem.querySelector(`[data-js="check"]`).classList.remove("hidden");
      // Set the hidden inputs value to the ID
      this.inputTarget.value = id;
    }
  }

  choose(e) {
    const selectItem = e.currentTarget;
    const id = selectItem.dataset.id;
    console.log({ selectItem, id, dataset: this.element.dataset });

    // Copy the label HTML and place it into the outer form element]
    this.selectedTarget.innerHTML =
      selectItem.querySelector(`[data-js="title"]`).outerHTML;
    // Set the hidden inputs value to the ID
    this.inputTarget.value = id;
    // Remove checkmarks from all other elements
    this.itemTargets.forEach((itemTarget) => {
      itemTarget.querySelector(`[data-js="check"]`).classList.add("hidden");
    });
    // Add checkmark to selected item.
    selectItem.querySelector(`[data-js="title"]`);
    selectItem.querySelector(`[data-js="check"]`).classList.remove("hidden");

    this.close();

    // Dispatch a change event on the hidden input so other controllers can listen
    this.inputTarget.dispatchEvent(
      new CustomEvent("change", { bubbles: true, detail: { value: id } })
    );

    if (this.element.dataset.autoSubmit === "true") {
      // Find the closest form submit button and click it
      const submitButtons = this.element
        .closest("form")
        .querySelectorAll("button[type=submit]");
      if (submitButtons.length > 0) {
        submitButtons[submitButtons.length - 1].click();
      }
    }
  }
}
